import {FC} from "react";
import {Container, Img, Wrapper} from "./common";

interface IBadge {
	height?: string;
	width?: string;
	img: string;
}

export const MockBadge: FC<IBadge> = ({height, width, img}) => {
	return (
		<Wrapper $width={width} $height={height}>
			<Container>
				<Img src={img} alt={"badge"} />
			</Container>
		</Wrapper>
	);
};
